import { useMemo, useState, useEffect } from "react";
import "./navbar.css";
import MenuIcon from "@mui/icons-material/Menu";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { readJson } from "../../utils/CommonUtil";
import defaultImage from "../../images/defaultImage.png";

export default function Navbar() {
  const { openSidebar, sideBar } = useProductsContext();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const broadcast = localStorage.getItem("broadcastConnection");
  const broadcastMessage = broadcast === "marketing-message";

  const pageDetails = useMemo(() => readJson("fbbPageDetail") || {}, []);
  const { facebook: { pageName = "", pagePictureUrl = "" } = {} } = pageDetails;

  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="top_section">
          <div
            className="logo-boxx"
            style={{
              width: sideBar ? "100%" : "80px",
              backgroundColor: "#fff",
            }}>
            <Link to="/home">
              <img
                src="./../../assets/images/logo-light.png"
                style={{ display: sideBar ? "block" : "none" }}
                alt="Caucuss"
                className="logo"
              />
            </Link>
            <span
              className="logo-sm"
              style={{ display: sideBar ? "none" : "flex" }}>
              <Link to="/home">
                <img
                  src="./../../assets/images/logo-sm.png"
                  alt="CaucusSm"
                  height="45"
                />
              </Link>
            </span>
          </div>
          <div
            style={{ marginLeft: sideBar ? "50px" : "30px", cursor: "pointer" }}
            className="bars">
            <MenuIcon onClick={openSidebar} />
          </div>
        </div>

        <div
          className="topLeft"
          style={{
            background: "white",
            marginLeft: sideBar ? "250px" : isMobile ? "100px" : "400px",
          }}>
          {broadcastMessage ? (
            <div className="widgets_div d-flex align-items-center">
              <div className="icon_div">
                <span>
                  {pagePictureUrl ? (
                    <img
                      src={pagePictureUrl}
                      className="rounded-circle avatar-sm"
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                      }}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </span>
              </div>
              <div className="av-div">{pageName}</div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
